export interface FeaturedTool {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  category: string;
}

export const featuredTools: FeaturedTool[] = [
  {
    id: 1,
    name: "ChatGPT",
    description: "Advanced AI chatbot with natural language processing",
    imageUrl: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=450&fit=crop&crop=center&auto=format&q=80",
    category: "Chatbots"
  },
  {
    id: 2,
    name: "Midjourney",
    description: "AI-powered image generation from text prompts",
    imageUrl: "https://images.unsplash.com/photo-1686191128892-3b4e0e4b8b3e?w=800&h=450&fit=crop&crop=center&auto=format&q=80",
    category: "Image Generation"
  },
  {
    id: 3,
    name: "Notion AI",
    description: "AI-powered workspace with smart organization",
    imageUrl: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&h=450&fit=crop&crop=center&auto=format&q=80",
    category: "Productivity"
  }
];